import { Permission } from '@shared/infrastructure/auth/permission.js';
import type { AppModule } from '@shared/presentation/router/composition.js';
import { VP_SECTION_NAV } from '../presentation/section-nav.js';

/**
 * `queue` feature of Virtual Profiler.
 *
 * HU-10 a HU-14. Es la primera pantalla que se llena: se resuelve con una sola
 * llamada al read-model de la cola, y valida la pasarela de punta a punta.
 *
 * It renders inside the shell, hence `layoutRoutes`. With no `meta.public` the
 * guard protects it, which is the default.
 */
export const virtualProfilerAnalysisQueueModule: AppModule = {
  name: 'virtual-profiler-queue',
  routes: [],
  layoutRoutes: [
    {
      path: 'virtual-profiler/queue',
      name: 'virtual-profiler-queue',
      component: () => import('./presentation/AnalysisQueueView.vue'),
      meta: { permission: Permission.VIRTUAL_PROFILER_READ, sectionNav: VP_SECTION_NAV },
    },
  ],
};
